import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { resetKanbanFilter, clearKanbanFilters } from '../actions';
import { selectKanbanFilter } from '../selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FormField } from '../../../components/FormFields';
import { Dropdown } from '../../../components/Dropdown';

const FiltersWrapper = styled.div`
  background-color: white;
  display: flex;
  gap: 10px;
  justify-content: start;
  align-items: center;
  padding: 12px 0;
  width: 100%;
  flex-wrap: wrap;
`;

const FilterLabel = styled.div`
  background-color: #d6d9dd;
  color: black;
  font-weight: bold;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 5px;
`;

const DeleteFilterButton = styled.div`
  cursor: pointer;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ClearButton = styled.span`
  font-weight: bold;
  font-size: 12px;
  color: #df4074;
  text-decoration: underline;
  cursor: pointer;
`;

/* eslint-disable react/prefer-stateless-function */
class FiltersCloudComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  deleteFilter = filterName => {
    this.props.reset(filterName);
  };

  clearAllFilters = () => {
    this.props.clearAll();
  };

  render() {
    const filtersList = this.props.filter?.properties;
    const filterName = name => this.lblStr(`vehicle.filter.${name}`);
    const filterValue = (value, type, label) => {
      if (value.id) {
        return value?.company_type !== 'individual' ? value?.name ?? '' : `${value?.name ?? ''} ${value?.surname ?? ''}`;
      }

      switch (type) {
        case 'multiple':
          return Array.isArray(label) ? label.join(', ') : value;
        default:
          return label && label[0] ? label[0] : value[0];
      }
    };

    return (
      <FiltersWrapper>
        {filtersList?.map(filter => (
          <FilterLabel key={filter?.key}>
            {`${filterName(filter?.key)}: ${filterValue(filter?.value, filter?.type, filter?.label)}`}
            <DeleteFilterButton onClick={() => this.deleteFilter(filter?.key)}>
              <FontAwesomeIcon icon={faTimes} />
            </DeleteFilterButton>
          </FilterLabel>
        ))}
        {!!filtersList.length && (
          <ClearButton onClick={this.clearAllFilters}>{this.lblStr('invoice.filter.clearAll')}</ClearButton>
        )}
      </FiltersWrapper>
    );
  }
}

FiltersCloudComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectKanbanFilter(),
  });

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    reset(filterName) {
      dispatch(resetKanbanFilter(filterName));
    },
    clearAll: () => {
      dispatch(clearKanbanFilters());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const FiltersCloud = compose(withConnect, withRouter, injectIntl)(FiltersCloudComp);
